"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("..");
var _utils = require("../../utils");
require("./styles.scss");
var RefundsHistory = function RefundsHistory(_ref) {
  var refunds = _ref.refunds;
  if (refunds.length < 1) return null;
  var columnsConfig = [{
    align: 'center',
    className: 'table-column',
    header: 'Date Processed',
    id: 'dateFormatted',
    field: 'dateFormatted',
    sortable: false,
    mobileProps: {
      visible: true
    }
  }, {
    align: 'right',
    className: 'table-column',
    header: 'Refund Amount',
    id: 'amountFormatted',
    field: 'amountFormatted',
    sortable: false,
    mobileProps: {
      visible: true
    }
  }];
  var refundsList = refunds.map(function (refund) {
    var r = refund;
    r.dateFormatted = _utils.numericDateFormatter.format(new Date(refund.dateProcessed));
    r.amountFormatted = (0, _utils.toDollar)(refund.refundAmount);
    return r;
  });
  var showScroll = refundsList.length > 3;
  var scrollClasses = (0, _classnames.default)('refund__scroll', {
    overflow: showScroll
  });
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    className: "refunds-history",
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund__section-title"
  }, "REFUNDS HISTORY"), /*#__PURE__*/_react.default.createElement(_.Table, {
    showScroll: showScroll,
    scrollClasses: scrollClasses,
    columns: columnsConfig,
    data: refundsList
  })));
};
RefundsHistory.defaultProps = {
  refunds: []
};
RefundsHistory.propTypes = {
  refunds: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    applicationId: _propTypes.number.isRequired,
    clientId: _propTypes.number.isRequired,
    dateProcessed: _propTypes.string,
    refundAmount: _propTypes.string.isRequired
  }))
};
var _default = exports.default = RefundsHistory;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/RefundsHistory/styles.scss');